export default __webpack_public_path__ + "static/media/last.a5c0a275.svg";